module.exports = __webpack_public_path__ + "static/media/wahana.456f1d35.png";